/**
 * Prefer the first video as the large hero; otherwise use the first item.
 * Remaining items are shown in the strip below (photos + other clips).
 */
export function splitHeroGallery(items) {
  if (!Array.isArray(items) || items.length === 0) {
    return { hero: null, heroIndex: -1, stripEntries: [] };
  }
  const videoIdx = items.findIndex((g) => g.type === 'video');
  const heroIndex = videoIdx >= 0 ? videoIdx : 0;
  const hero = items[heroIndex];
  const stripEntries = items
    .map((item, index) => ({ item, index }))
    .filter(({ index }) => index !== heroIndex);
  return { hero, heroIndex, stripEntries };
}
